export const state = {
  persons: [],
};
